import visitorsClassicScenario from './visitors-classic';

/**
 * Sets up Employee Schedule Mirage Scenario
 * - `MIRAGE_SCENARIO='employee-schedule' yarn start:mirage`
 *
 * @param {object} server Mirage Server
 */
export default function (server) {
  const {
    company,
    subscription,
    locations: [SFLocation],
  } = visitorsClassicScenario(server);

  company.update({ planIntent: 'enterprise', plan: 'enterprise', period: 'yearly' });
  SFLocation.update({
    employeeScreeningEnabled: true,
    registrationEligibilityEndOffset: 1440,
    registrationEligibilityStartOffset: -1440,
  });
  server.create('location-role', { role: 'Employee' });
  // VR Subscription
  subscription.update({
    trialEndDate: null,
    last4: '1234',
    expirymonth: 10,
    expiryyear: 2021,
    brand: 'Visa',
    plan: 'enterprise',
    period: 'yearly',
    couponPercentOff: 10,
    features: [
      'pre_registration_required',
      'billing',
      'sign_in_visitors',
      'custom_notifications',
      'group_sign_in',
      'nda_enabled',
      'visitor_photos',
      'visitor_badge_printing',
      'sms_notification',
      'slideshows',
      'custom_badge',
      'presign_nda',
      'multiple_visitor_types',
      'sign_in_from_invite',
      'slack',
      'analytics',
      'assistants',
      'blacklist',
      'locations_grouping',
      'global_analytics',
      'rooms-calendar-permissions',
    ],
  });
  // Employee screening flow
  server.create('flow', 'withES', { locationId: SFLocation.id });
  // Rooms subscription
  server.create('subscription', { app: 'rooms', companyId: company.id });
  // Desks subscription
  server.create('subscription', 'asDesksSubscribed', { companyId: company.id });
  // server.create('subscription', 'asDesksOnTrial', { companyId: 1 });
  server.create('desk-location', { companyId: company.id, locationId: SFLocation.id });

  // Setup admin floors with ember-data
  const [floor1, floor2] = server.createList('floor', 2, {
    locationId: SFLocation.id,
    floorPlanUrl: 'https://picsum.photos/460/300',
  });
  server.createList('desk', 5, 'asUnplaced', { floor: floor1 });
  server.createList('desk', 10, 'asUnplaced', { floor: floor2 });
}
